"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var actionTypes_1 = require("../notifications/actionTypes");

var rest_api_1 = require("@nimles/rest-api");

var actionTypes_2 = require("../identity/actionTypes");

var globalId = 0;
var STARTED = 'STARTED';
var COMPLETED = 'COMPLETED';

exports.parseJwt = function (token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
};

function apiAction(actionObject, requestAction, responseAction, options) {
  var _this = this;

  if (options === void 0) {
    options = {
      disableRefreshTokens: false
    };
  }

  return function (dispatch, getState) {
    return __awaiter(_this, void 0, void 0, function () {
      var id, state, auth, _a, accessToken, refreshToken, jwt, response, result, _b;

      var _c, _d, _e, _f, _g;

      return __generator(this, function (_h) {
        switch (_h.label) {
          case 0:
            globalId++;
            id = globalId.toString();
            dispatch({
              type: actionTypes_1.ADD_NOTIFICATION,
              id: id,
              data: __assign(__assign({}, actionObject), {
                status: STARTED
              })
            });
            state = getState();
            auth = state.auth;
            if (!(!((_c = options) === null || _c === void 0 ? void 0 : _c.disableRefreshTokens) && auth.refreshToken && auth.clientId && auth.expires && auth.expires * 1000 < Date.now())) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , rest_api_1.refreshTokens(auth.clientId, auth.refreshToken)];

          case 1:
            _a = _h.sent(), accessToken = _a.accessToken, refreshToken = _a.refreshToken;
            jwt = accessToken && exports.parseJwt(accessToken);
            dispatch({
              type: actionTypes_2.REFRESH_USER_TOKENS,
              data: {
                accessToken: accessToken,
                refreshToken: refreshToken,
                expires: (_d = jwt) === null || _d === void 0 ? void 0 : _d.exp
              }
            });
            _h.label = 2;

          case 2:
            return [4
            /*yield*/
            , requestAction(state)];

          case 3:
            response = _h.sent();
            if (!responseAction) return [3
            /*break*/
            , 5];
            return [4
            /*yield*/
            , responseAction(response)];

          case 4:
            _b = _h.sent();
            return [3
            /*break*/
            , 6];

          case 5:
            _b = response;
            _h.label = 6;

          case 6:
            result = _b;

            if ((_e = result) === null || _e === void 0 ? void 0 : _e.data) {
              dispatch(__assign(__assign({}, actionObject), result));
              dispatch({
                type: actionTypes_1.UPDATE_NOTIFICATION,
                id: id,
                data: __assign(__assign({}, actionObject), {
                  status: COMPLETED
                })
              });
              return [2
              /*return*/
              , (_g = (_f = result) === null || _f === void 0 ? void 0 : _f.data, _g !== null && _g !== void 0 ? _g : result)];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };
}

exports.apiAction = apiAction;